export default "__VITE_ASSET__c6b091a9__"